import supportChatQueries from "$/lib/queries/support-chat-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/support-chat")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(supportChatQueries.adminThreads())
    return { crumb: "Supportchattar" }
  },
})
